const data = {
	"width": 256,
	"height": 256,
	"body": "<path fill=\"currentColor\" d=\"M228 39.3A12.1 12.1 0 0 0 216.7 28c-39.7-2.3-74.8 2.4-104.2 13.9s-50 28.2-62.9 49.6c-17.7 29.2-17.7 64.6-.5 98.4l-17.6 17.6a12 12 0 0 0 0 17a12.1 12.1 0 0 0 17 0l17.6-17.6c16.8 8.5 34 12.9 50.6 12.9a91.6 91.6 0 0 0 47.8-13.4c21.4-12.9 38.5-34.7 49.6-62.9S230.3 79 228 39.3Zm-75.9 146.6c-20.2 12.2-43.9 13.1-68 2.9l84.4-84.3a12 12 0 0 0-17-17l-84.3 84.4c-10.2-24.1-9.3-47.8 2.9-68c21-34.6 70.7-53.8 134.4-52.4c1.5 63.6-17.8 113.4-52.4 134.4Z\"/>"
};
export default data;
